"use strict";
exports.__esModule = true;
exports.isInBrowser = exports.isInWorker = exports.isInWindow = void 0;
var isInWindow = function () { return typeof window !== 'undefined'; };
exports.isInWindow = isInWindow;
var isInWorker = function () { return typeof WorkerGlobalScope !== 'undefined'; };
exports.isInWorker = isInWorker;
var isInBrowser = function () { return exports.isInWindow() || exports.isInWorker(); };
exports.isInBrowser = isInBrowser;
//# sourceMappingURL=isInBrowser.js.map